import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

// Fix icon
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

let DefaultIcon = L.icon({
    iconUrl: icon,
    shadowUrl: iconShadow,
    iconSize: [25, 41],
    iconAnchor: [12, 41]
});
L.Marker.prototype.options.icon = DefaultIcon;

// 1. Helper to detect clicks
const MapEvents = ({ onLocationSelect }) => {
  useMapEvents({
    click(e) {
      onLocationSelect(e.latlng.lat, e.latlng.lng);
    },
  });
  return null;
};

// 2. Helper to move the map programmatically (When address is found)
const MapController = ({ lat, lng }) => {
  const map = useMap();
  useEffect(() => {
    if (lat && lng) {
      map.flyTo([lat, lng], 16); // Fly to the new coordinates with zoom 16
    }
  }, [lat, lng, map]);
  return null;
};

const LocationPicker = ({ lat, lng, onLocationSelect }) => {
  // Default to Zurich if nothing selected yet
  const defaultCenter = [47.3717597, 8.5426102]; 
  const center = (lat && lng) ? [lat, lng] : defaultCenter;

  return (
    <div className="h-64 w-full rounded-lg overflow-hidden border border-gray-300 shadow-inner z-0 relative">
      <MapContainer 
        center={center} 
        zoom={13} 
        style={{ height: '100%', width: '100%' }}
      >
        <TileLayer
          attribution='&copy; OpenStreetMap'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        
        {/* Helper components */}
        <MapEvents onLocationSelect={onLocationSelect} />
        <MapController lat={lat} lng={lng} />

        {/* Marker */}
        {lat && lng && <Marker position={[lat, lng]} />}
      </MapContainer>
    </div>
  );
};

export default LocationPicker;
